"use client";

import { UserSubscriptionUsage } from "@prisma/client";
import React from "react";

interface SubscriptionUsageContextType {
  usage: Omit<UserSubscriptionUsage, "createdAt" | "updatedAt"> | null;
}

const SubscriptionUsageContext = React.createContext<
  SubscriptionUsageContextType | undefined
>(undefined);

export function SubscriptionUsageProvider(
  props: React.PropsWithChildren<SubscriptionUsageContextType>,
) {
  return (
    <SubscriptionUsageContext value={{ usage: props.usage }}>
      {props.children}
    </SubscriptionUsageContext>
  );
}

export function useSubscriptionUsage() {
  const context = React.use(SubscriptionUsageContext);
  if (!context) {
    throw new Error(
      "useSubscriptionUsage must be used within a SubscriptionUsageProvider",
    );
  }
  return context.usage;
}

export function useIsMacroEnabled() {
  const usage = useSubscriptionUsage();
  if (!usage) {
    return false;
  }
  return usage.macroEconomy;
}

export function useIsScreenerEnabled() {
  const usage = useSubscriptionUsage();
  if (!usage) {
    return false;
  }
  return usage.assetScreener;
}

export function useIsSubscriptionActive() {
  const usage = useSubscriptionUsage();
  if (!usage) {
    return false;
  }
  return usage.periodEnd.getTime() > Date.now();
}
